const { VITE_HIDE_HOME } = import.meta.env;
const Layout = () => import('@/layout/index.vue');

export default {
  path: '/',
  name: 'Home',
  component: Layout,
  meta: {
    icon: 'home-filled',
    title: '首页',
    rank: 0,
    permission: ['root', 'admin', 'user', 'common']
  },
  children: [
    {
      path: '/home',
      name: 'Welcome',
      component: () => import('@/views/home/index.vue'),
      meta: {
        title: '首页',
        showLink: VITE_HIDE_HOME === 'true' ? false : true
      }
    }
  ]
};
